import React from 'react';
import { MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#12284C] text-gray-400 py-12 border-t border-gray-800" data-id="element-48">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-50">
          <div className="mb-6 md:mb-0 flex flex-col items-center md:items-start" data-id="element-51">
            <img src="https://cdn.magicpatterns.com/uploads/uocWpxXnpG3Xo9epouC9Rg/logo_voxspace-horizontal.png" alt="vox space Logo" className="h-10 w-auto mb-4 brightness-0 invert opacity-80" data-id="element-52" />
          </div>

          <div className="flex space-x-6 mb-6 md:mb-0" data-id="element-53">
            <a href="https://pezula.ai/neo-imprint/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm" data-id="element-54">
              Impressum
            </a>
            <a href="https://pezula.ai/neo-data-privacy/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-sm" data-id="element-55">
              Datenschutz
            </a>
            <a href="mailto:dialog@voxspace.de" className="hover:text-white transition-colors text-sm" data-id="element-56">
              Kontakt
            </a>
            <a href="https://wa.me/491786745380" target="_blank" rel="noopener noreferrer" className="hover:text-green-400 transition-colors flex items-center gap-1.5 text-sm" data-id="element-57">
              <MessageCircle className="w-4 h-4" data-id="element-58" />
              WhatsApp
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-sm" data-id="element-59">
          <p data-id="element-60">© 2026 NEO Software Gesellschaft mbH. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>;
}